import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

// Automatischer Logout-Redirect bei 401 (Cookie abgelaufen / Session weg).
// Verhindert die rote "Uncaught runtime error"-Overlay-Seite.
api.interceptors.response.use(
  (resp) => resp,
  (error) => {
    const status = error?.response?.status;
    const url = error?.config?.url || "";
    const onLoginPage =
      typeof window !== "undefined" &&
      (window.location.pathname === "/login" || window.location.pathname === "/register");
    // /auth/me wird zur Sitzungsprüfung verwendet — Fehler dort sind normal vor dem Login.
    const isAuthCheck = url.includes("/auth/me") || url.includes("/auth/login");
    if (status === 401 && !onLoginPage && !isAuthCheck) {
      // Sanfte Weiterleitung – keine Schleifen, kein Crash
      try {
        const next = encodeURIComponent(window.location.pathname + window.location.search);
        window.location.replace(`/login?expired=1&next=${next}`);
      } catch (_) {
        /* ignore */
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Etwas ist schiefgelaufen. Bitte erneut versuchen.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
